import * as InteractionTypes from './types'

/**
 * @INFO Agregar una nueva interacción
 * @param data
 * @returns
 */
export const addInteractionAction = (data: InteractionTypes.IPathInteraction) => (
  (dispatch: Function) => {
    if(data){
      dispatch(addInteraction(data))
      return
    }
  }
)

const addInteraction = (data: InteractionTypes.IPathInteraction) => ({
  type: InteractionTypes.ADD_INTERACTION,
  payload: data
})

/**
 * @INFO Eliminar la interacción
 * @returns
 */
export const deleteInteractionAction = () => (
  (dispatch: Function) => {
    dispatch(deleteInteraction())
    return
  }
)

const deleteInteraction = () => ({
  type: InteractionTypes.DELETE_INTERACTION
})
